import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CoreLookUpService } from 'src/app/services/feature/kb-my-cores/kbMyCores.service';

@Component({
  selector: 'app-coreLookup',
  templateUrl: './KbcoreLookup.component.html',
  styleUrls: ['./KbcoreLookup.component.scss'],
  standalone: false
})
export class KbCoreLookupComponent {
  subscription = new Subscription();
  oneAtATime: boolean = true;
  isMobile: boolean = false;
  isFirstOpen: boolean = true;
  selectedIndex: boolean[] = new Array(5).fill(false);
  apidata$: Observable<any> = this.service.getDocsApi();
  constructor(public breakpointObserver: BreakpointObserver,
    private service: CoreLookUpService,
    private cdr: ChangeDetectorRef) {

  }
  ngOnInit() {
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));
  }
  log(event: any, index) {
    this.switchAtIndex(this.selectedIndex, index);
  }

  switchAtIndex(array: boolean[], index: number): void {
    if (index >= 0 && index < array.length) {
      array[index] = !array[index];
      this.cdr.detectChanges();
    } else {
      console.error("Index out of bounds.");
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
